module.exports = __webpack_public_path__ + "src/components/@molecules/Cart/images/1O33Utz.svg";